import React, { useState, useEffect } from 'react';
import {} from 'reactstrap';
import { toast } from 'react-toastify';
import Api from '../../util/api';
import Loading from '../../shared/components/custom/Loading';
import t, { partial } from '../../util/translation/translation';
import moment from 'moment';
import LotteryContactForm from './components/LotteryContactForm';
import OfferTypes from '../offers/types';

const LotteryContactFormPage = ({ lottery }) => {
  const [scheduleMessageID, setScheduleMessageID] = useState(null);
  const [scheduleMessagesForEvent, setScheduleMessagesForEvent] = useState([]);
  const [messageStatus, setMessageStatus] = useState('Scheduled');
  const [totalAmountOfScheduledMessages, setTotalAmountOfScheduledMessages] =
    useState(0);
  const [startDate, setStartDate] = useState();
  const p = partial('lottery');
  const s = partial('shared');
  const o = partial('OffersFormPage');

  const handleContact = async (values) => {
    const { title, message, type, timeToSend, notificationLabel } = values;
    const scheduledDate =
      timeToSend === 'SCHEDULED' ? moment.utc(startDate).format() : null;
    const payload = {
      title,
      message,
      receiverType: values.receiverType.value,
      notificationLabel: notificationLabel?.value || null,
    };

    try {
      if (timeToSend === 'SCHEDULED' && scheduleMessageID) {
        await Api.lottery.communication.updateScheduledMessage(
          lottery.id,
          scheduleMessageID,
          { ...payload, scheduledDate }
        );
        toast.success(`${t('ScheduledMessagesPage.scheduleMessageUpdated')}`);
      } else if (timeToSend === 'INSTANT') {
        await Api.lottery.communication.contactLottery(lottery.id, payload);
      } else {
        await Api.lottery.communication.contactLottery(lottery.id, {
          ...payload,
          scheduledDate,
        });
        toast.success(`${t('ScheduledMessagesPage.messageScheduled')}`);
      }
      if (timeToSend === 'INSTANT') {
        if (type === OfferTypes.CommunicationTypes.push) {
          toast.success(o(`${'pushNotificationSent'}`));
        } else if (type === OfferTypes.CommunicationTypes.email) {
          toast.success(o(`${'emailSent'}`));
        } else {
          toast.success(o(`${'smsSent'}`));
        }
      }
    } catch (_e) {
      toast.error(s(`${'somethingWentWrong'}`));
    }
    getScheduleMessagesByServiceId();
    setScheduleMessageID(null);
  };
  const getScheduleMessagesByServiceId = async (page = 1, pageSize = 10) => {
    try {
      let messageByEventId = [];

      if (messageStatus === t('ScheduledMessagesPage.filterByStatus')) {
        messageByEventId =
          await Api.scheduleMessages.getScheduleMessagesByServiceId(
            lottery.id,
            page,
            pageSize
          );
      } else {
        messageByEventId =
          await Api.scheduleMessages.getScheduleMessagesByServiceIdByStatus(
            lottery.id,
            page,
            pageSize,
            messageStatus
          );
      }
      setScheduleMessagesForEvent(messageByEventId.data.data);
      setTotalAmountOfScheduledMessages(messageByEventId.data.total);
    } catch (error) {
      console.log(error);
      toast.error(error);
    }
  };

  return (
    <LotteryContactForm
      onSubmit={handleContact}
      lottery={lottery}
      scheduleMessageID={scheduleMessageID}
      setScheduleMessageID={setScheduleMessageID}
      scheduleMessagesForEvent={scheduleMessagesForEvent}
      getScheduleMessagesByServiceId={getScheduleMessagesByServiceId}
      setScheduleMessagesForEvent={setScheduleMessagesForEvent}
      totalAmountOfScheduledMessages={totalAmountOfScheduledMessages}
      messageStatus={messageStatus}
      setMessageStatus={setMessageStatus}
      startDate={startDate}
      setStartDate={setStartDate}
    />
  );
};

export default LotteryContactFormPage;
